import { useTranslation } from '@/app/components/translations/Translation';
import type {
  BaggageFilterChange,
  HandBaggageFilterChange,
} from '@/app/components/hotel-detail/changeTransport/ChangeTransportFiltersCommon';
import { useTransportPageFilterTracking } from '@/app/components/hotel-detail/changeTransport/hooks/useTransportPageFilterTracking';
import {
  EvoCheckboxRow,
  EvoFilterLoadingLayer,
  EvoFilterSection,
} from '@/app/components/hotel-detail/evo/transport/EvoTransportFilters/filters/EvoFilterShared';

type EvoBaggageFilterProps = {
  baggageIncluded?: BaggageFilter[];
  handBaggageIncluded?: BaggageFilter[];
  onChange: (filterChange: BaggageFilterChange | HandBaggageFilterChange) => void;
};

export function EvoBaggageFilter(props: EvoBaggageFilterProps) {
  const { baggageIncluded, handBaggageIncluded, onChange } = props;
  const { t } = useTranslation();
  const sendStratrackFlightPageFilterEvent = useTransportPageFilterTracking();

  const hasHandBaggage = !!handBaggageIncluded && handBaggageIncluded.length > 0;
  const hasBaggage = !!baggageIncluded && baggageIncluded.length > 0;
  if (!hasHandBaggage && !hasBaggage) return null;

  return (
    <EvoFilterSection>
      {handBaggageIncluded?.map((handBaggage) => (
        <EvoCheckboxRow
          key={`evo-hand-baggage-${handBaggage.name}`}
          id={`evo-hand-baggage-${handBaggage.name}`}
          label={t('vacation.common.filters.baggage.hand')}
          checked={handBaggage.selected}
          disabled={!handBaggage.enabled}
          onChange={() => {
            sendStratrackFlightPageFilterEvent({
              filterName: 'HAND_BAGGAGE_FILTER',
              value: `${!handBaggage.selected}`,
              deselectFlag: handBaggage.selected,
            });
            onChange({
              newState: { handBaggageIncluded: [{ ...handBaggage, selected: !handBaggage.selected }] },
              event: { type: 'FILTER', origin: 'BAGGAGE_FILTER' },
            });
          }}
        />
      ))}
      {baggageIncluded?.map((baggage) => (
        <EvoCheckboxRow
          key={`evo-baggage-${baggage.name}`}
          id={`evo-baggage-${baggage.name}`}
          label={t('vacation.common.filters.baggage.checked')}
          checked={baggage.selected}
          disabled={!baggage.enabled}
          onChange={() => {
            sendStratrackFlightPageFilterEvent({
              filterName: 'CHECKED_BAGGAGE_FILTER',
              value: `${!baggage.selected}`,
              deselectFlag: baggage.selected,
            });
            onChange({
              newState: { baggageIncluded: [{ ...baggage, selected: !baggage.selected }] },
              event: { type: 'FILTER', origin: 'BAGGAGE_FILTER' },
            });
          }}
        />
      ))}
      <EvoFilterLoadingLayer origins={['BAGGAGE_FILTER']} />
    </EvoFilterSection>
  );
}
